// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + (chunkId === "869" ? "__federation_expose_NPCGenerator" : chunkId) + "." + {"466": "81e4c4a1aaede59f","476": "b21ceb7c20aad08a","70": "cb4bed050901e9b0","869": "e32eb80cb40aca71","95": "9159a2956e94cd1d",}[chunkId] + ".js"
}